<template>
    <div>
        <input type="hidden" id="ipUser" value="">
        <div id="myModal" class="modal">
            <!-- Modal content -->
            <div class="modal-content modal-contents login-modal">
                <span class="close" @click="modalClose()">&times;</span>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="illustration">
                            <h1>Login to My E-Campus</h1>
                            <div class="login-img">
                                <img src="https://user-images.githubusercontent.com/72601463/145770698-0c9ac217-c329-4ae1-9c5b-5dbec14efd24.png">
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="login-form">
                            <img src="https://user-images.githubusercontent.com/72601463/145772566-ecb05f6d-0a17-4458-95d8-72d3e6a444db.png">
                            <form action="" @submit.prevent="login">
                                <h1>Login</h1>
                                <div class="username">
                                    <label class="username" for="username">Username</label>
<!--                                    <input type="text" id="username" placeholder="Enter Username">-->
                                    <input type="text" class="form-control" id="username" placeholder="Username or Email" required autofocus v-model="username">
                                </div>
                                <div class="password">
                                    <label class="password" for="password">Password</label>
<!--                                    <input type="text" id="password" placeholder="Enter Your Password">-->
                                    <div class="pass-field">
                                        <input type="password" class="passWord" id="password"
                                               placeholder="Password" required v-model="password">
                                        <div class="viewPass" @click="changeInputType($event)"><i class="far fa-eye"></i></div>
                                    </div>
                                </div>
                                <div class="rem-rec">
<!--                                    <label class="form-remember">-->
<!--                                        <input type="checkbox"/>Remember Me-->
<!--                                    </label>-->
                                    <a class="form-recovery" href="https://www.empoweryouth.com/forgot-password" target="_blank">Forgot your password ?</a>
                                </div>
                                <button type="submit" class="login-form-submit">Login</button>
                            </form>
                            <p>Don't have an Account? <router-link to="/signup" class="yellow">SignUp</router-link></p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import toastr from '../../public/js/toastr.js';
    import {hideLoader, showLoader} from "../_helpers/apiHelper";

    export default {
        name: 'login',
        data: function () {
            return {
                username: '',
                password: ''
            }
        },
        updated() {
            if (localStorage.token && localStorage.source) {
                $('#myModal').css({"display": "none"});
            }
        },
        created() {
            if (localStorage.token && localStorage.source) {
                $('#myModal').css({"display": "none"});
            }
        },
        mounted() {
            $.ajax({
                type: 'GET',
                async: false,
                url: 'https://api.ipify.org?format=json',
                success: function (data) {
                    $('#ipUser').val(data['ip']);
                }
            })
        },
        methods: {
            modalClose() {
                $('#myModal').css({"display": "none"});
            },
            login() {
                showLoader();
                var a = this;
                var bodyFormData = new FormData();
                bodyFormData.set('username', this.username);
                bodyFormData.set('password', this.password);
                bodyFormData.set('source', document.getElementById('ipUser').value);

                var url = this.$store.getters.getDomain;

                axios({
                    method: 'POST',
                    url: `${url}api/v2/auth/login`,
                    data: bodyFormData,
                    config: {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                })
                    .then(function (response) {
                        a.loginSuccessful(response['data']);
                    })
                    .catch(function (error) {
                        hideLoader();
                        toastr.error('Something went wrong. Please try again.', 'Oops!!');
                    })
            },
            loginSuccessful(res) {
                if (!res['response']['access_token']) {
                    this.loginFailed();
                    hideLoader();
                    return;
                }

                toastr.success('Successfully logged in', 'Success');


                //local storage tokens setup
                localStorage.token = res['response']['access_token'];
                localStorage.source = res['response']['source']
                localStorage.user_type = res['response']['user_type'];

                //state user setup
                this.$store.dispatch('setLoggedIn', res['response']);

                // set axios common properties
                axios.defaults.headers.common['Authorization'] = "Bearer " + res['response']['access_token'];
                axios.defaults.headers.common['source'] = res['response']['source']
                location.reload();
                $('#myModal').css({"display": "none"});
            },
            loginFailed() {
                delete localStorage.token;
                delete localStorage.source;
                toastr.error('Your email and password is not correct', 'Oops!!');
            },
            changeInputType(event){
                let btn = event.currentTarget;
                let parentElem = btn.parentElement
                let passFiled = parentElem.querySelector('.passWord');
                let passtype = passFiled.getAttribute('type');
                if(passtype == 'text'){
                    passFiled.setAttribute('type','password');
                    btn.classList.remove('passActive');
                }else {
                    passFiled.setAttribute('type','text');
                    btn.classList.add('passActive');
                }
              }
        }
    }
</script>

<style scoped>
@media screen and (max-width: 767px) {
    .log-form{
        padding: 0px 15px;
        margin-top: 80px;
    }
}
.login-modal .col-sm-6{
    padding: 0;
}
.login-modal .row{
    margin: 0;
}
.login-modal{
    max-width: 800px;
    height: 480px;
    margin: 50px auto;
    border-radius: 8px;
    overflow: hidden !important;
    top: 50%;
    transform: translateY(-50%);
    margin-top: 0;
}
.illustration{
    background: url('https://user-images.githubusercontent.com/72601463/145768659-c1956ef6-44ef-4e49-bef7-b967bd60589b.png');
    background-repeat: no-repeat;
    background-size: cover;
    height: 480px;
    padding-top:20px;
}
.illustration h1, .login-form h1{
    font-size: 22px;
    color: #fff;
    margin: 0;
    padding: 20px 0 10px 20px;
    font-weight: 700;
    font-family: montserrat;
    position: relative;
}
.illustration h1::before{
    content: "";
    position: absolute;
    display: inline-block;
    width: 60px;
    background: #E45E05;
    height: 2px;
    bottom: 0;
    left: 20px;
}
.illustration .login-img{
    max-width: 220px;
    margin: auto;
    padding: 60px 0;
}
.illustration .login-img img{
    width: 100%;
}
.login-form{
    background: #F9F9F9;
    height: 480px;
    padding: 0 20px;
    position: relative;
    padding-top:20px;
}
.login-form img{
    display: block;
    margin: auto;
}
.login-form h1{
    color: #333;
    padding: 0;
    margin-top: 0;
}
.login-form form > div{
    margin-top: 20px;
}
.login-form form label{
    display: block;
    font-size: 14px;
    color: #777;
}
.login-form form input, .login-form-submit{
    width: 100%;
    border: 0;
    margin-top: 5px;
    line-height: 22px;
    padding: 10px 15px;
    font-size: 13px;
    height:auto;
}
.login-form form input::placeholder{
    color: #aaa;
}
.login-form form input:focus{
    outline: none;
}
.login-form form .rem-rec{
    display: flex;
    margin-top: 10px;
    justify-content: right;
}
.form-remember input{
    width: fit-content !important;
    display: inline-block;
    margin-right: 5px;
}
.login-form-submit{
    max-width: 220px;
    display: block;
    margin: auto;
    background: #2EB0E9;
    margin-top: 20px !important;
    color: #fff;
}
.login-form p{
    font-size: 13px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: fit-content;
}
.login-form p a.yellow{
    color: #E45E05;
    cursor: pointer;
}
.login-form p a.yellow:hover{
    text-decoration: underline;
}

@media only screen and (max-width: 767px){
    .illustration{
        display: none;
    }
}
</style>